
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DatePicker from "./DatePicker.vue";
import { CustomFieldConfig } from "./internal/types";
import { SelectItem } from "../common";
import * as util from "../../util";
import * as lang from "@/lib/language";
import * as countries from "@/lib/countries";

type ValueType = string | boolean;

@Component({
  components: { DatePicker }
})
export default class CustomField extends Vue {
  internalValue: ValueType = "";
  hasError = false;
  @Prop({ default: "" }) value!: ValueType;
  @Prop({ default: "primary" }) color!: string;
  @Prop({ required: true }) field!: CustomFieldConfig;
  @Prop({ default: "ES" }) langKey!: lang.LangKey;

  @Watch("internalValue")
  changeValue(newValue: string) {
    if (this.value !== newValue) {
      this.$emit("input", newValue);
    }
  }

  @Watch("value")
  onValue(newValue: string) {
    if (this.internalValue !== newValue) {
      this.internalValue = newValue;
    }
  }

  get boolValue(): boolean {
    return this.internalValue === true || this.internalValue === "true";
  }
  set boolValue(val: boolean) {
    this.internalValue = val;
  }

  created() {
    this.internalValue = this.value;
  }

  get langCountries(): lang.LangCountries {
    return lang.getLangCountries(this.langKey);
  }

  get lang() {
    return lang.getStrings(this.langKey);
  }

  get fieldOptions(): SelectItem[] {
    return (this.field.possibleValues || []).map((val) => {
      return { text: val, value: val };
    });
  }

  get fieldOrCountryOptions(): SelectItem[] {
    let result: SelectItem[] = [];
    if (this.field.type === "country_iso2") {
      result = countries.getCountryAlpha2(this.langCountries);
    } else if (this.field.type === "country_iso3") {
      result = countries.getCountryAlpha3(this.langCountries);
    } else if (this.field.type === "country_iso3_num") {
      result = countries.getCountryNum3(this.langCountries);
    } else {
      result = this.fieldOptions;
    }
    if (!this.field.required) {
      result.unshift({ text: "-", value: "" });
    }
    return result;
  }

  get fieldRules() {
    const rules: util.ValidationRule[] = [];
    if (this.field.required) {
      rules.push(util.rules.required(this.lang.ruleRequired));
    }
    if (this.field.type === "number") {
      rules.push(util.rules.numeric(this.lang.ruleNumeric, true, true));
    }
    if (this.field.type == "email") {
      rules.push(util.rules.email(this.lang.ruleEmail, true));
    }
    if (this.field.maxLength) {
      rules.push(
        util.rules.length(
          this.lang.ruleMaxLength.replace("%0", this.field.maxLength.toString()),
          0,
          this.field.maxLength
        )
      );
    }
    return rules;
  }
}
